import { ReactElement, useRef } from "react";
import MaterialIcon from "./MaterialIcon";

interface ModalProps {
  title?: string;
  children: ReactElement<any, any>;
  open: boolean;
  closeModal: () => void;
  fixed?: boolean;
  smallScreenOnly?: boolean;
}

function Modal({
  title,
  children,
  open,
  closeModal,
  fixed,
  smallScreenOnly,
}: ModalProps) {
  let containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      className={` absolute left-0 top-0 ${open ? "flex" : "hidden"} t h-full w-full items-center justify-center bg-black bg-opacity-75 ${smallScreenOnly ? "lg:content lg:relative lg:flex lg:h-auto lg:w-auto lg:bg-inherit" : ""}`}
      onClick={(e) =>
        fixed ?? e.target === containerRef.current ? closeModal() : {}
      }
    >
      <div className="lg:content bg-grayscale-900 rounded-lg p-2 lg:bg-inherit lg:p-0">
        <div className="flex justify-between align-middle lg:hidden">
          {title ?? <div className="">{title}</div>}
          {fixed ?? (
            <button className="" onClick={() => closeModal()}>
              <MaterialIcon icon="close" />
            </button>
          )}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}

export default Modal;
